import React, { useContext } from 'react';
import Marquee from "react-fast-marquee";
import './Skills.css'
import { ThemeContext } from '../../contexts/ThemeContext';
import { skillsData } from '../../data/skillsData';
import { skillsImage } from '../../utils/skillsImage';

function Skills() {

    const { theme } = useContext(ThemeContext);

    return (
        <div className="skills">
            <div className="skillsHeader">
                <h2 style={{ color: theme.primary }}>Skills</h2>
            </div>
            <div className="skillsContainer">
                <div className="skill--scroll">
                   

                <Marquee 
                        gradient={false} 
                        speed={80} 
                        pauseOnHover={true}
                        pauseOnClick={true} 
                        delay={0}
                        play={true} 
                        direction="left"
                    >
                        {skillsData.map((skill, id) => {
                            const icon = skillsImage(skill);
                            return (
                            <div className="skill--box" key={id}>
                                {icon && (
                                    <div className="skill--box-iconWrap">
                                        <img src={icon} alt="" />
                                    </div>
                                )}
                                <h3 style={{color: theme.tertiary}}>
                                    {skill}
                                </h3>
                            </div>
                            );
                        })}
                    </Marquee>
                    
                </div>
            </div>
        </div>
    )
}

export default Skills
